import { Col, Nav, Row, Tab } from 'react-bootstrap'
import AccountManager from '../accountManager/AccountManager'
import UsersPage from './UserPage'
import { useAppSelector } from '../../../hooks';
import { constraintConfig } from '../../../constraintConfig';
import { selectAuth } from '../../../features/authSlice';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

type LocationState = {
  activeTab?: string;
};

const UsersPageWrapper = () => {
  const { roleID } = useAppSelector(selectAuth);
  const location = useLocation();
  const locationState = location.state as LocationState | null;
  const [tabChange, setTabChange] = useState('');
  const [activeTab, setActiveTab] = useState('first');

  useEffect(() => {
    if (locationState?.activeTab === 'second') {
      setActiveTab('second');
      setTabChange('second');
    }
  }, [locationState]);

  const handleTabSelect = (selectedKey:any) => {
    setTabChange(selectedKey);
    setActiveTab(selectedKey);
  };
  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{labelKey.userList}</PageTitle> */}
      <div className='card mb-5'>
        <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={handleTabSelect}>
          <Row>
            {/* <div className='card-header border-0 pt-6'> */}
            <Col sm={12}>
              <Nav variant="pills" className='p-5 border-bottom'>
                <Nav.Item>
                  <Nav.Link eventKey="first">Active Users</Nav.Link>
                </Nav.Item>
                {(roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.role4) &&
                  <Nav.Item>
                    <Nav.Link eventKey="second">Onboarding Users Request</Nav.Link>
                  </Nav.Item>
                }
              </Nav>
            </Col>
            {/* </div> */}
            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <UsersPage tabChange={tabChange} />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <AccountManager tabChange={tabChange} />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </>
  )
}

export default UsersPageWrapper